import React, { useEffect } from "react";
import "../../App.css";
import { useMediaQuery } from "react-responsive";
import blueLoops from "../../images/blueloops/blueloops.png";
import "./BlueLoops.css";

export default function BlueLoops() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  return (
    <>
      <div className="filmfriends-container">
        {/* Header Section */}
        <div className="blue-loops-header-section">
          <div className="header-content">
            <div className="header-text">
              <h1 className="title">BlueLoops</h1>
              <div className="extra-text">
                <p className="text">
                  Blueloops is a personal project I created to share and
                  showcase crochet patterns. I designed the interface in Figma
                  and developed the site using Next.js and TypeScript, ensuring
                  fast performance and scalability. The responsive layout
                  provides a seamless experience across different devices. I
                  integrated Pocketbase as the database to manage data storage
                  efficiently, and the website is hosted on Netlify for reliable
                  and fast deployment. This project reflects my passion for both
                  crochet and web development, bringing together creativity and
                  technology in a space where I can share my work with others.
                </p>

                {isMobile ? (
                  <p className="textSBold">
                    Made with:
                    <ul class="text">
                      <li>Figma</li>
                      <li>Next.js</li>
                      <li>TypeScript</li>
                      <li>Tailwind</li>
                      <li>Pocketbase</li>
                      <li>Netlify</li>
                    </ul>
                  </p>
                ) : (
                  <p className="text">
                    Made with:
                    <strong>
                      {" "}
                      Figma ◦ Next.js ◦ TypeScript ◦ Tailwind ◦ Pocketbase ◦
                      Netlify
                    </strong>
                  </p>
                )}
                <p className="text">
                  Check out the website here:{" "}
                  <a
                    href="https://blueloops.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://blueloops.netlify.app
                  </a>
                </p>
              </div>
            </div>
            <img className="header-image" src={blueLoops} alt="BlueLoops" />
          </div>
        </div>
      </div>
    </>
  );
}
